<template>
  <div id="jointOrderAFollow">
    <!-- <van-nav-bar title="跟进" fixed placeholder left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
    </van-nav-bar> -->
    <van-form
      ref="form"
      validate-trigger="onBlur"
      @submit="onSubmit"
      input-align="right"
      :scroll-to-error="true"
    >
      <van-field
          readonly
          name="community"
          v-model="form.communityName"
          label="小区"
          placeholder="点击搜索小区>"
          clearable @click-right-icon.stop="clearCommunityName" right-icon="close"
          @click="
             showHouse = true;
                searchValueHouse = '';
          "
        />
      <van-field
        readonly
        clickable
        required
        name="priceModelId"
        v-model="form.priceModelName"
        label="定价宝"
        placeholder="点击选择>"
        @click="showFixPriceModel = true;gainCommunityIndex(form.priceModelName)"
        :rules="[{ required: true, message: '请选择定价宝' }]"
      />
      <van-field
        :readonly="true"
        :clickable="Boolean(form.communityName)"
        name="buildingType"
        v-model="buildingTypeList[form.buildingType-1]"
        label="楼栋号"
        placeholder="点击选择>"
        @click="selectBuildingType"
        
      />
      
       <van-field
        v-model="form.buildingNo"
        label="楼号"
        type="number"
        @focus="End($event)"
        placeholder="请输入楼号"
       
        >
      </van-field>
        <van-field
        v-model="form.unitNo"
        label="单元号"
        type="number"
        @focus="End($event)"
        placeholder="请输入单元号"
 
        >
      </van-field>
       <van-field
        v-model="form.roomNo"
        label="房间号"
        type="number"
        @focus="End($event)"
        placeholder="请输入房间号"
     
        >
      </van-field>

     

      <van-field
        v-model="address"
        label="地址"
        readonly
        >
      </van-field>

      <van-field
        readonly
        name="community"
        v-model="form.communityName"
        label="小区"
        placeholder="点击搜索小区>"
        clearable
        @click-right-icon.stop="clearCommunityName"
        right-icon="close"
        @click="
          showHouse = true;
          searchValueHouse = '';
        "
      />
      <van-field
        readonly
        clickable
        required
        name="priceModelId"
        v-model="form.priceModelName"
        label="定价宝"
        placeholder="点击选择>"
        @click="
          showFixPriceModel = true;
          gainCommunityIndex(form.priceModelName);
        "
        :rules="[{ required: true, message: '请选择定价宝' }]"
      />
      <van-field
        :readonly="true"
        :clickable="Boolean(form.communityName)"
        name="buildingType"
        v-model="buildingTypeList[form.buildingType - 1]"
        label="楼栋号"
        placeholder="点击选择>"
        @click="selectBuildingType"
      />

      <van-field
        v-model="form.buildingNo"
        label="楼号"
        type="number"
        @focus="End($event)"
        placeholder="请输入楼号"
         :rules="[ {
                validator: validNum,
                message: '请输入正确的楼号',
              },]"
      >
      </van-field>
      <van-field
        v-model="form.unitNo"
        label="单元号"
        type="number"
        @focus="End($event)"
        placeholder="请输入单元号"
         :rules="[ {
                validator: validNum,
                message: '请输入正确的单元号',
              },]"
      >
      </van-field>
      <van-field
        v-model="form.roomNo"
        label="房间号"
        type="number"
        @focus="End($event)"
        placeholder="请输入房间号"
        :rules="[ {
                validator: validNum,
                message: '请输入正确的房间号',
              },]"
      >
      </van-field>

      <van-field v-model="address" label="地址" readonly> </van-field>

      <van-field
        readonly
        clickable
        required
        name="decorationType"
        :value="form.decorationTypeName"
        label="装修类型"
        placeholder="点击选择>"
        @click="showRemodel = true"
        :rules="[{ required: true, message: '请选择装修类型' }]"
      />

      <van-row class="floor_box">
        <van-col span="50">
          <van-field
            v-model="form.floorNumber"
            type="number"
            required
            name="floorNumber"
            label="楼层"
            @focus="End($event)"
            placeholder="当前楼层"
            @change="changeReset"
            :rules="[
              {
                required: true,
                trigger: ['onChange', 'onBlur'],
                message: '请输入当前楼层',
              },
              {
                validator: validNum,
                message: '请输入正确楼层数',
              },
              {
                trigger: ['onChange', 'onBlur'],
                validator: (item) => {
                  return Number(form.floorNumber) <= Number(form.totalFloor);
                },
                message: '当前楼层数不能大于总楼层数',
              },
            ]"
          >
            <template #right-icon> F </template>
          </van-field>
        </van-col>
        <van-col span="2">/</van-col>
        <van-col span="11">
          <van-field
            type="number"
            v-model="form.totalFloor"
            name="totalFloor"
            placeholder="总楼层"
            @change="changeReset"
            @focus="End($event)"
            :rules="[
              {
                required: true,
                trigger: ['onChange', 'onBlur'],
                message: '请输入总楼层',
              },
              {
                validator: validNum,
                message: '请输入正确楼层数',
              },
              {
                trigger: ['onChange', 'onBlur'],
                validator: (item) => {
                  return Number(form.floorNumber) <= Number(form.totalFloor);
                },
                message: '当前楼层数不能大于总楼层数',
              },
            ]"
          >
            <template #right-icon> F </template>
          </van-field>
        </van-col>
      </van-row>

      <van-field
        readonly
        clickable
        name="decorationBefore"
        :value="decorationBeforeName"
        label="装修前户型"
        placeholder="点击选择>"
        @click="
          showDecorationBefore = true;
          DecorationBeforeList[0].defaultIndex = +form.chamberNumOld || 0;
          DecorationBeforeList[1].defaultIndex = +form.hallNumOld || 0;
          DecorationBeforeList[2].defaultIndex = +form.toiletNumberOld || 0;
          DecorationBeforeList[3].defaultIndex = +form.kitchenNumOld || 0;
          DecorationBeforeList[4].defaultIndex = +form.balconyNumOld || 0;
        "
        :rules="[{ required: true, message: '请选择装修前户型' }]"
      />

      <van-field
        readonly
        clickable
        name="decorationAfter"
        :value="decorationAfterName"
        label="装修后户型"
        placeholder="点击选择>"
        @click="
          showDecorationAfter = true;
          DecorationBeforeList[0].defaultIndex = +form.chamberNum || 0;
          DecorationBeforeList[1].defaultIndex = +form.hallNum || 0;
          DecorationBeforeList[2].defaultIndex = +form.toiletNumber || 0;
          DecorationBeforeList[3].defaultIndex = +form.kitchenNum || 0;
          DecorationBeforeList[4].defaultIndex = +form.balconyNum || 0;
        "
        :rules="[{ required: true, message: '请选择装修后户型' }]"
      />

      <van-field
        ref="elevator"
        name="elevator"
        label="有无电梯"
        :rules="[{ required: true, message: '请选择是否有电梯' }]"
      >
        <template #input>
          <van-radio-group v-model="form.elevator" direction="horizontal">
            <van-radio name="1" @click="changeReset" shape="square"
              >有</van-radio
            >
            <van-radio name="0" @click="changeReset" shape="square"
              >无</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        required
        name="totalAcreage"
        v-model="form.totalAcreage"
        label="总面积"
        type="number"
        @focus="End($event)"
        @change="changeReset"
        @blur="clearnumber(form.totalAcreage, 2, form, 0, true)"
        placeholder="请输入面积"
        :rules="[
          { required: true, message: '请填写面积' },
          {
            validator: validNumMoreDecimal2,
            message: '面积必须大于0且只能保留两位小数',
          },
        ]"
        ><template #right-icon> m² </template>
      </van-field>

      <!-- <van-field></van-field> -->
      <!-- 房间 -->
      <template v-if="form.roomList.length && form.roomList">
        <van-cell
          class="house_add"
          v-for="(item, index) in form.roomList"
          :key="index"
        >
          <div class="top">
            <div class="title">
              <span>{{ item.name }}</span>
            </div>
            <div
              class="room_edit"
              style="color: #fd7e2d"
              @click="showRoomAddPopup(item, index)"
            >
              编辑
              <!-- <van-button type="primary" size="mini">编辑</van-button> -->
            </div>
          </div>
          <div class="options">
            <div class="option">面积：{{ item.acreage || "--" }}m²</div>
            <div class="option" style="justify-content: center">
              朝向:{{ toWardsList[item.toward] }}
            </div>
            <van-checkbox
              class="option"
              style="justify-content: flex-end"
              v-model="item.bayWindow"
              disabled
              shape="square"
              ><span>飘窗</span></van-checkbox
            >
            <van-checkbox
              class="option"
              v-model="item.optimization"
              disabled
              shape="square"
              >优化间</van-checkbox
            >
            <van-checkbox
              class="option"
              style="justify-content: center"
              v-model="item.balcony"
              disabled
              shape="square"
              >独立阳台</van-checkbox
            >
            <van-checkbox
              class="option"
              style="justify-content: flex-end"
              v-model="item.toilet"
              disabled
              shape="square"
              >独卫</van-checkbox
            >
          </div>
          <div class="img_upload">
            <van-uploader
              v-model="item.imageUrls"
              :max-count="3"
              :before-read="beforeRead"
              :after-read="
                (fileItem) => {
                  item.imageUrls.pop();
                  item.imageUrls.push({
                    url: upload_qiniu_addr + fileItem.file.key,
                  });
                  $refs.form.resetValidation('roomList');
                }
              "
            />
            <div class="text">
              <van-field
                name="roomList"
                disabled
                :rules="[
                  {
                    validator: (items) => {
                      return Boolean(item.imageUrls.length) || !imgUp;
                    },
                    message: '请上传至少一张图片',
                  },
                ]"
              />
            </div>
          </div>
        </van-cell>
      </template>

      <!-- 卫生间 -->
       <template  v-if="form.toiletList.length && form.toiletList">
          <van-cell class="house_add"
          v-for="(item, index) in form.toiletList"
          :key="index">
           <div>
            <van-row class="top">
              <van-col span="12">
                <div class="title box">
                  <span>{{ item.name }} </span>
                  <div style="margin-left: 0.8rem">
                    {{ item.toiletFlag ? "独卫" : "公共" }}
                  </div>
                </div>
              </van-col>

              <van-col span="12"
                ><div class="box has_border">
                  <van-field
                    style="padding: 0"
                    input-align="left"
                    label="面积"
                    type="number"
                    v-model="item.acreage"
                    @blur="clearnumber(item.acreage, 2, form.toiletList, index)"
                    placeholder="请输入面积"
                    :rules="[
                      { required: true, message: '请填写面积' },
                      {
                        validator: validNumMoreDecimal2,
                        message: '面积必须大于0且只能保留两位小数',
                      },
                    ]"
                  >
                    <template #right-icon> m² </template>
                  </van-field>
                </div></van-col
              >
            </van-row>
          </div>
          <div class="img_upload">
            <van-uploader
              v-model="item.imageUrls"
              :max-count="3"
              :before-read="beforeRead"
              :after-read="
                (fileItem) => {
                  item.imageUrls.pop(),
                    item.imageUrls.push({
                      url: upload_qiniu_addr + fileItem.file.key,
                    });
                  item.imageList = [];
                  item.imageUrls.forEach((item) => {
                    item.imageList.push(item.url);
                  });
                  $refs.form.resetValidation('toiletList');
                }
              "
            />
            <div class="text" v-if="!item.imageUrls.length">
              <van-field
                name="toiletList"
                disabled
                :rules="[
                  {
                    validator: (items) => {
                      return Boolean(item.imageUrls.length) || !imgUp;
                    },
                    message: '请上传至少一张图片',
                  },
                ]"
              />
            </div>
          </div>
          </van-cell>
         
       
      </template>
      
     
      <!-- 客厅 -->
      <template v-if="form.hallList.length && form.hallList">
        <van-cell
          class="house_add"
          v-for="(item, index) in form.hallList"
          :key="index"
        >
          <van-row class="top">
            <van-col span="12">
              <div class="title box">
                <span>{{ item.name }}</span>
              </div></van-col
            >
            <van-col span="12"
              ><div class="box has_border">
                <van-field
                  style="padding: 0"
                  input-align="left"
                  type="number"
                  label="面积"
                  v-model="item.acreage"
                  @blur="clearnumber(item.acreage, 2, form.hallList, index)"
                  placeholder="请输入面积"
                  :rules="[
                    { required: true, message: '请填写面积' },
                    {
                      validator: validNumMoreDecimal2,
                      message: '面积必须大于0且只能保留两位小数',
                    },
                  ]"
                >
                  <template #right-icon> m² </template>
                </van-field>
              </div></van-col
            >
          </van-row>

          <div class="img_upload">
            <van-uploader
              v-model="item.imageUrls"
              :max-count="3"
              :before-read="beforeRead"
              :after-read="
                (fileItem) => {
                  item.imageUrls.pop(),
                    item.imageUrls.push({
                      url: upload_qiniu_addr + fileItem.file.key,
                    });
                  $refs.form.resetValidation('hallList');
                }
              "
            />
            <div class="text">
              <van-field
                name="hallList"
                disabled
                :rules="[
                  {
                    validator: (items) => {
                      return Boolean(item.imageUrls.length) || !imgUp;
                    },
                    message: '请上传至少一张图片',
                  },
                ]"
              />
            </div>
          </div>
        </van-cell>
      </template>

      <!-- 厨房 -->
      <template v-if="form.kitchenList.length && form.kitchenList">
        <van-cell>
          <div
            class="house_add"
            v-for="(item, index) in form.kitchenList"
            :key="index"
          >
            <van-row class="top">
              <van-col span="12">
                <div class="title box">
                  <span>{{ item.name }}</span>
                </div></van-col
              >
              <van-col span="12"
                ><div class="box has_border">
                  <van-field
                    style="padding: 0"
                    input-align="left"
                    label="面积"
                    v-model="item.acreage"
                    @focus="End($event)"
                    type="number"
                    @blur="
                      clearnumber(item.acreage, 2, form.kitchenList, index)
                    "
                    placeholder="请输入面积"
                    :rules="[
                      { required: true, message: '请填写面积' },
                      {
                        validator: validNumMoreDecimal2,
                        message: '面积必须大于0且只能保留两位小数',
                      },
                    ]"
                  >
                    <template #right-icon> m² </template>
                  </van-field>
                </div></van-col
              >
            </van-row>

            <div class="img_upload">
              <van-uploader
                v-model="item.imageUrls"
                :max-count="3"
                :before-read="beforeRead"
                :after-read="
                  (fileItem) => {
                    item.imageUrls.pop(),
                      item.imageUrls.push({
                        url: upload_qiniu_addr + fileItem.file.key,
                      });
                    $refs.form.resetValidation('kitchenList');
                  }
                "
              />
              <div class="text">
                <van-field
                  name="kitchenList"
                  disabled
                  :rules="[
                    {
                      validator: (items) => {
                        return Boolean(item.imageUrls.length) || !imgUp;
                      },
                      message: '请上传至少一张图片',
                    },
                  ]"
                />
              </div>
            </div>
          </div> </van-cell
      ></template>

      <!-- 阳台 -->
      <template v-if="form.balconyList.length && form.balconyList">
        <van-cell>
          <div
            class="house_add"
            v-for="(item, index) in form.balconyList"
            :key="index"
          >
            <van-row class="top">
              <van-col span="12">
                <div class="title box">
                  <span>{{ item.name }}</span>
                </div></van-col
              >
              <van-col span="12"
                ><div class="box has_border">
                  <van-field
                    style="padding: 0"
                    input-align="left"
                    label="面积"
                    v-model="item.acreage"
                    @focus="End($event)"
                    type="number"
                    @blur="
                      clearnumber(item.acreage, 2, form.balconyList, index)
                    "
                    placeholder="请输入面积"
                    :rules="[
                      { required: true, message: '请填写面积' },
                      {
                        validator: validNumMoreDecimal2,
                        message: '面积必须大于0且只能保留两位小数',
                      },
                    ]"
                  >
                    <template #right-icon> m² </template>
                  </van-field>
                </div></van-col
              >
            </van-row>

            <div class="img_upload">
              <van-uploader
                v-model="item.imageUrls"
                :max-count="3"
                :before-read="beforeRead"
                :after-read="
                  (fileItem) => {
                    item.imageUrls.pop(),
                      item.imageUrls.push({
                        url: upload_qiniu_addr + fileItem.file.key,
                      });
                    $refs.form.resetValidation('balconyList');
                  }
                "
              />
              <div class="text">
                <van-field
                  name="balconyList"
                  disabled
                  :rules="[
                    {
                      validator: (items) => {
                        return Boolean(item.imageUrls.length) || !imgUp;
                      },
                      message: '请上传至少一张图片',
                    },
                  ]"
                />
              </div>
            </div>
          </div> </van-cell
      ></template>

      <!-- 户型图 -->
      <template v-if="form.layoutList.length && form.layoutList">
        <van-cell>
          <div
            class="house_add"
            v-for="(item, index) in form.layoutList"
            :key="index"
          >
            <div class="top">
              <div class="title">户型图</div>
            </div>

            <div class="img_upload">
              <van-uploader
                v-model="item.imageUrls"
                :max-count="3"
                :before-read="beforeRead"
                :after-read="
                  (fileItem) => {
                    item.imageUrls.pop(),
                      item.imageUrls.push({
                        url: upload_qiniu_addr + fileItem.file.key,
                      });
                    $refs.form.resetValidation('layoutList');
                  }
                "
              />
              <div class="text">
                <van-field
                  name="layoutList"
                  disabled
                  :rules="[
                    {
                      validator: (items) => {
                        return Boolean(item.imageUrls.length) || !imgUp;
                      },
                      message: '请上传至少一张图片',
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </van-cell>
      </template>

      <template class="price">
        <van-submit-bar 
          class="price" 
          text-align="left"
          label="预计出租价格："
          button-text="获取"
        >
          <template #default>
            <div>
              预计出租价格:
              <span style="color: red; font-weight: bold"
                >¥ {{ form.expectPrice == null ? "" : form.expectPrice }}</span
              >
            </div>
          </template>
          <template #button>
            <div class="create_price">
              <van-icon
                name="eye-o"
                v-if="form.expectPrice"
                @click="lookPriceRemark"
                size="24"
                style="margin-right: 0.3rem"
              />
              <van-button
                @click="createPrice"
                :loading="expectPriceLoading"
                native-type="button"
                size="small"
                type="primary"
                >获取</van-button
              >
            </div>
          </template>
        </van-submit-bar>
      </template>
      <!-- <van-divider>我是有底线的</van-divider> -->
      <div style="height: 1.2rem"></div>
      <div class="btn">
        <van-button
          round
          block
          type="primary"
          :loading="saveLoad"
          :disabled="saveLoad"
          native-type="submit"
          >保存</van-button
        >
      </div>
    </van-form>

    <!-- 小区搜索 -->

    <transition name="van-slide-right">
      <div v-if="showHouse" class="search">
        <form action="/">
          <van-search
            v-model="searchValueHouse"
            shape="round"
            show-action
            placeholder="请输入小区地址搜索"
            @input="onSearchHouse"
            @search="onSearchHouse"
            @cancel="onCancel"
          />
        </form>

        <van-cell
          v-for="house in communityList"
          :key="house.id"
          :title="house.name"
          icon="wap-home-o"
          @click="changeCommunity(house)"
        ></van-cell>

        <van-loading v-if="searchLoad" size="24" />

        <div v-else-if="searchValueHouse && !communityList.length">
          暂无数据
        </div>
      </div>
    </transition>
    <!-- 装修类型 -->
    <van-popup v-model="showRemodel" position="bottom">
      <van-picker
        show-toolbar
        :columns="decorationTypeList"
        value-key="desc"
        @confirm="
          (item) => {
            if (!item) return;
            form.decorationType = item.type;
            form.decorationTypeName = item.desc;
            this.reset()
            showRemodel = false;
          }
        "
        @cancel="showRemodel = false"
      />
    </van-popup>
    <!-- 定价宝下拉 -->
     <van-popup v-model="showFixPriceModel" position="bottom">
      <van-picker
        show-toolbar
        :columns="fixPriceList"
        value-key="name"
        :default-index="communityIndex"
        @confirm="
          (item,index) => {
            if (!item) return;
            form.priceModelId = item.id;
            form.priceModelName = item.name;
            form.priceModelIndex = index
            showFixPriceModel = false;
            this.reset()
          }
        "
        @cancel="showFixPriceModel = false"
      />
    </van-popup>
    <!-- 楼栋号下拉 -->
     <van-popup v-model="showBuildingTypeModel" position="bottom">
      <van-picker
        show-toolbar
        :columns="buildingTypeList"
        value-key="label"
        @confirm="
          (item,index) => {
            if (!item) return;
            form.decorationType = item.type;
            form.decorationTypeName = item.desc;
            this.reset();
            showRemodel = false;
          }
        "
        @cancel="showBuildingTypeModel = false"
      />
    </van-popup>
    <!-- 定价宝下拉 -->
    <van-popup v-model="showFixPriceModel" position="bottom">
      <van-picker
        show-toolbar
        :columns="fixPriceList"
        value-key="name"
        :default-index="communityIndex"
        @confirm="
          (item, index) => {
            if (!item) return;
            form.priceModelId = item.id;
            form.priceModelName = item.name;
            form.priceModelIndex = index;
            showFixPriceModel = false;
            this.reset();
          }
        "
        @cancel="showFixPriceModel = false"
      />
    </van-popup>
    <!-- 楼栋号下拉 -->
    <van-popup v-model="showBuildingTypeModel" position="bottom">
      <van-picker
        show-toolbar
        :columns="buildingTypeList"
        value-key="label"
        @confirm="
          (item, index) => {
            if (!item) return;
            form.buildingTypeName = item;
            form.buildingType = index + 1;
            showBuildingTypeModel = false;
          }
        "
        @cancel="showBuildingTypeModel = false"
      />
    </van-popup>
    <van-popup v-model="showDecorationBefore" position="bottom">
      <van-picker
        show-toolbar
        :columns="DecorationBeforeList"
        value-key="text"
        @confirm="
          (item) => {
            if (!item) return;
            form.chamberNumOld = item[0].text;
            (form.hallNumOld = item[1].text),
              (form.toiletNumberOld = item[2].text);
            form.kitchenNumOld = item[3].text;
            form.balconyNumOld = item[4].text;
            showDecorationBefore = false;
          }
        "
        @cancel="showDecorationBefore = false"
      >
        <template slot="columns-top">
          <div class="room_option">
            <span>室</span>
            <span>厅</span>
            <span>卫</span>
            <span>厨</span>
            <span>阳台</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showDecorationAfter" position="bottom">
      <van-picker
        show-toolbar
        :columns="DecorationBeforeList"
        value-key="text"
        @confirm="confirmDecorationAfter"
        @cancel="showDecorationAfter = false"
      >
        <template slot="columns-top">
          <div class="room_option">
            <span>室</span>
            <span>厅</span>
            <span>卫</span>
            <span>厨</span>
            <span>阳台</span>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="showTowards" position="bottom">
      <van-picker
        show-toolbar
        :columns="toWardsLists"
        value-key="desc"
        @confirm="
          (item) => {
            if (!item) return;
            toward = item.name;
            showTowards = false;
            this.reset();
          }
        "
        @cancel="showTowards = false"
      />
    </van-popup>
    <van-popup
      :close-on-click-overlay="false"
      style="width: 90%; padding: 15px 20px; border-radius: 4px"
      v-model="showRoomAdd"
      position="center"
    >
      <h3 style="margin: 0.24rem 0">编辑房间信息</h3>
      <van-form
        v-if="form.roomList.length"
        @submit="onSubmitForm(houseRoomIndex)"
      >
        <!-- acreage:"",
      toward:"",
      optimization:false,
      balcony:false,
      bayWindow:false,
      toilet:false, -->
        <van-field
          v-model="acreage"
          name="面积"
          label="面积"
          type="number"
          @blur="clearRoomNumber(acreage, 2, form.roomList, houseRoomIndex)"
          placeholder="请输入面积"
          :rules="[
            { required: true, message: '请填写面积' },
            {
              validator: validNumMoreDecimal2,
              message: '面积必须大于0且只能保留两位小数',
            },
          ]"
        />
        <van-field
          readonly
          clickable
          name="toward"
          :value="toWardsList[toward]"
          label="朝向"
          placeholder="点击选择>"
          @click="showTowards = true"
          :rules="[{ required: true, message: '请选择房间朝向' }]"
        />
        <van-row
          style="
            margin-top: 0.25rem;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            padding: 0.4rem;
          "
        >
          <van-checkbox
            style="width: 50%; margin: 0.2rem 0"
            class="option"
            v-model="bayWindow"
            @click="bayWindow = Number(bayWindow)"
            shape="square"
            ><span>飘窗</span></van-checkbox
          >
          <van-checkbox
            style="width: 50%; margin: 0.2rem 0"
            class="option"
            v-model="optimization"
            @click="optimization = Number(optimization)"
            shape="square"
            >优化间</van-checkbox
          >
          <van-checkbox
            style="width: 50%; margin: 0.2rem 0"
            class="option"
            v-model="balcony"
            @click="balcony = Number(balcony)"
            shape="square"
            >独立阳台</van-checkbox
          >
          <van-checkbox
            style="width: 50%; margin: 0.2rem 0"
            class="option"
            v-model="toilet"
            @click="toilet = Number(toilet)"
            shape="square"
            >独卫</van-checkbox
          >
        </van-row>
        <div style="margin: 16px; display: flex; justify-content: space-around">
          <van-button
            size="small"
            @click="cancel"
            style="width: 30%"
            round
            block
            type="default"
            native-type="button"
            >取消</van-button
          >
          <van-button
            size="small"
            style="width: 30%"
            round
            block
            type="primary"
            native-type="submit"
            >确认</van-button
          >
        </div>
      </van-form>
    </van-popup>
    <van-popup style="width:90%;height:80%;border-radius:8px;background:#333;color:#fff;overflow:hidden" v-model="showRemark">
      <div class="priceRemark" style="text-align:left;width:92%;height:92%;margin:4%;overflow-x: hidden;

overflow-y: scroll;">{{form.priceRemark}}</div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  requestJointOrderDecorationType,
  requestCommunitySearch, //分散式小区
  requestJointOrderCustomerDetail,
  requestChildStatus,
  requestJointOrderUpdate,
  requestFixPriceSelect,
  requestCreatePrice,
  requestCustomerTrackrecord,
  requestQiniuToken, //七牛token
  requestValidHouse,
} from "@/api";
import { validNum, validNumMoreDecimal2 } from "@/utils/validate";
import request from "@/utils/request";
import { formatDate, formatDatetime } from "@/utils/index";
import { imgUp } from "@/common/js/constant.js";
import { compress, compressAccurately } from "image-conversion";
import setItem$ from "dingtalk-jsapi/api/util/domainStorage/setItem";
export default {
  name: "jointOrderAFollow",
  data() {
    return {
      showRemark:false,
      isCreatePrice: false,
      imgUp: imgUp,
      result: [],
      bNum: 0,
      showHouse: false,
      communityList: [],
      searchLoad: false,
      fixPriceList: [],
      showFixPriceModel: false,
      showBuildingTypeModel: false,
      communityIndex: 0, //定价包Index
      expectPriceLoading: false,
      form: {
        address: "",
        expectPrice: null,
        communityId: "",
        communityName: "",
        priceModelId: "",
        priceModelName: "",
        buildingType: "",
        buildingTypeName: "",
        buildingNo: "",
        roomNo: "",
        unitNo: "",
        id: "1243565765754324",
        decorationType: "",
        decorationTypeName: "",
        priceRemark: "",
        chamberNumOld: "",
        hallNumOld: "",
        toiletNumberOld: "",

        chamberNum: "",
        hallNum: "",
        balconyNum: "",

        toiletNumber: "",
        totalAcreage: "",
        roomList: [],
        toiletList: [],
        hallList: [],
        kitchenList: [],
        balconyList: [],
        layoutList: [],
        elevator: 0,
      },
      showStatus: false,
      decorationTypeList: [],
      showDate: false,
      showRemodel: false, //装修类型picker 显示隐藏
      showDecorationBefore: false, //装修前户型picker 显示隐藏
      showDecorationAfter: false, //装修后户型picker 显示隐藏
      showTowards: false,
      showRoomAdd: false,
      saveLoad: false,
      DecorationBeforeList: [
        // 第一列
        {
          values: [
            {
              text: "0",
            },
            {
              text: "1",
            },
            {
              text: "2",
            },
            {
              text: "3",
            },
            {
              text: "4",
            },
            {
              text: "5",
            },
            {
              text: "6",
            },
            {
              text: "7",
            },
            {
              text: "8",
            },
          ],
          // values: ["室",0,1,2,3,4,5],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: [
            {
              text: "0",
            },
            {
              text: "1",
            },
            {
              text: "2",
            },
            {
              text: "3",
            },
            {
              text: "4",
            },
            {
              text: "5",
            },
            {
              text: "6",
            },
            {
              text: "7",
            },
            {
              text: "8",
            },
          ],
          defaultIndex: 0,
        },
        {
          values: [
            {
              text: "8",
            },
          ],
          defaultIndex: 0,
        },
        {
          values: [
            {
              text: "0",
            },
            {
              text: "1",
            },
            {
              text: "2",
            },
            {
              text: "3",
            },
            {
              text: "4",
            },
            {
              text: "5",
            },
            {
              text: "6",
            },
            {
              text: "7",
            },
            {
              text: "8",
            },
          ],
          defaultIndex: 0,
        },
        {
          values: [
            {
              text: "0",
            },
            {
              text: "1",
            },
            {
              text: "2",
            },
            {
              text: "3",
            },
            {
              text: "4",
            },
            {
              text: "5",
            },
            {
              text: "6",
            },
            {
              text: "7",
            },
            {
              text: "8",
            },
          ],
          defaultIndex: 0,
        },
        {
          values: [
            {
              text: "0",
            },
            {
              text: "1",
            },
            {
              text: "2",
            },
            {
              text: "3",
            },
            {
              text: "4",
            },
            {
              text: "5",
            },
            {
              text: "6",
            },
            {
              text: "7",
            },
            {
              text: "8",
            },
          ],
          defaultIndex: 0,
        },
      ],
      capture: ["camera"],
      //房间名称
      roomNameList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      areaList: {
        province_list: [1, 2, 3, 4, 5],
        city_list: [1, 2, 3, 4, 5],
        county_list: [1, 2, 3, 4, 5],
        // province_list: {
        //   110000: "北京市",
        //   120000: "天津市",
        // },
        // city_list: {
        //   110100: "北京市",
        //   120100: "天津市",
        // },
        // county_list: {
        //   110101: "东城区",
        //   110102: "西城区",
        //   // ....
        // },
      },
      toWardsList: {
        S: "朝南",
        E: "朝东",
        W: "朝西",
        N: "朝北",
      },
      toWardsLists: [
        { desc: "朝南", name: "S" },
        { desc: "朝东", name: "E" },
        { desc: "朝西", name: "W" },
        { desc: "朝北", name: "N" },
      ],
      checkBoxList: [
        { label: "优化间", value: 1, isCheck: false },
        { label: "独立阳台", value: 2, isCheck: false },
        { label: "飘窗", value: 3, isCheck: false },
        { label: "独卫", value: 4, isCheck: false },
      ],
      qiniuData: {
        key: "",
        token: "",
      },
      houseRoomIndex: 0,
      roomFrom: {
        //点击编辑后的弹框 当前房间的信息
      },
      acreage: "",
      toward: "",
      optimization: 0,
      balcony: 0,
      bayWindow: 0,
      toilet: 0,
      toiletDisabled: false,
    };
  },
  computed: {
    ...mapState([
      // "idTypeList",
      // "destineList",
      // "payList",
      // "contractList",
      // "customerList",
      "upload_qiniu_addr",
      "buildingTypeList",
    ]),
    decorationBeforeName() {
      return `${this.form.chamberNumOld ? this.form.chamberNumOld : "0"} 室 ${
        this.form.hallNumOld ? this.form.hallNumOld : "0"
      } 厅 ${this.form.toiletNumberOld ? this.form.toiletNumberOld : "0"} 卫 ${
        this.form.kitchenNumOld ? this.form.kitchenNumOld : "0"
      } 厨 ${this.form.balconyNumOld ? this.form.balconyNumOld : "0"} 阳台`;
      // if (
      //   this.form.chamberNumOld ||
      //   this.form.hallNumOld ||
      //   this.form.toiletNumberOld ||
      //   this.form.kitchenNumOld ||
      //   this.form.balconyNumOld
      // ) {
      //   // this.DecorationBeforeList[0].defaultIndex = this.form.chamberNumOld
      // } else {
      //   return "";
      // }
    },
    decorationAfterName() {
      return `${this.form.chamberNum ? this.form.chamberNum : "0"} 室 ${
        this.form.hallNum ? this.form.hallNum : "0"
      } 厅 ${this.form.toiletNumber ? this.form.toiletNumber : "0"} 卫 ${
        this.form.kitchenNum ? this.form.kitchenNum : "0"
      } 厨 ${this.form.balconyNum ? this.form.balconyNum : "0"} 阳台`;
      // if (
      //   this.form.chamberNum ||
      //   this.form.hallNum ||
      //   this.form.toiletNumber ||
      //   this.form.kitchenNum ||
      //   this.form.balconyNum
      // ) {
      // } else {
      //   return "";
      // }
    },
    address: function () {
      let address = "";
      if (this.form.communityName) {
        address += `${this.form.communityName}`;
      }
      if (this.form.buildingNo) {
        address += `${this.form.buildingNo}${
          this.buildingTypeList[this.form.buildingType - 1]
        }`;
      }
      if (this.form.unitNo) {
        address += `${this.form.unitNo}单元`;
      }
      if (this.form.roomNo) {
        address += `${this.form.roomNo}室`;
      }
      this.$set(this.form, "address", address);

      return address;
    },
    // address:{
    //   get(){
    //     // console.log("fuck")
    //     return this.form.roomNo
    //   },
    //   set(newValue){
    //     console.log(newValue)
    //     console.log(this)
    //     this.form.address = newValue
    //   }
    //   // return `${this.form.buildingNo?this.form.buildingNo+this.form.buildingNo?this.buildingTypeList[this.form.buildingType -1]:''}`
    // //   get:function(){
    // //     return `${this.form.buildingNo}${this.buildingTypeList[this.form.buildingType -1]}${this.form.unitNo}单元${this.form.roomNo}号`
    // //   },
    // //    set: function () {
    // // }
    // }
  },
  created() {
    this.form.customerId = this.$route.query.id;
    this.getTrackRecord();
    this.form.address = "";
  },
  mounted() {
    this.getDetail();
    this.getDecorationType();
    this.getFixPriceList();
    this.getQiniuToken();
  },
  methods: {
    getDetail() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestJointOrderCustomerDetail(this.$route.query.id)
        .then((res) => {
          this.form = res.data;
          this.form.roomList.forEach((item, index) => {
            item.imageUrls = item.imageUrls.map((items) => {
              return {
                url: items,
              };
            });
            item.toiletDisabled = false;
          });
          this.form.toiletList.forEach((item, index) => {
            item.imageUrls = item.imageUrls.map((items) => {
              return {
                url: items,
              };
            });
          });
          this.form.hallList.forEach((item, index) => {
            item.imageUrls = item.imageUrls.map((items) => {
              return {
                url: items,
              };
            });
          });
          this.form.balconyList.forEach((item, index) => {
            item.imageUrls = item.imageUrls.map((items) => {
              return {
                url: items,
              };
            });
          });
          this.form.kitchenList.forEach((item, index) => {
            item.imageUrls = item.imageUrls.map((items) => {
              return {
                url: items,
              };
            });
          });
          this.form.layoutList.forEach((item, index) => {
            item.imageUrls = item.imageUrls.map((items) => {
              return {
                url: items,
              };
            });
          });
          if (this.form.layoutList.length < 1) {
            this.form.layoutList = [
              {
                acreage: "",
                imageUrls: [],
              },
            ];
          }

          this.form.elevator = Number(this.form.elevator) + "";
          // this.DecorationBeforeList[0].defaultIndex = res.data.chamberNumOld || 0;
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    End(e) {
      //input获取光标显示在最后
      let obj = e.srcElement;
      obj.focus();
      const len = obj.value.length;
      //光标定位要加上 setTimeOut，不然就会重新光标定位失败
      setTimeout(() => {
        obj.selectionStart = obj.selectionEnd = len;
      }, 60);
    },
    clearNoNum(value, index, indexs) {
      if (value) {
        let value1 = parseFloat(value);
        value = value1 == 0 ? "" : value;
        let i = value.indexOf(".");
        value = i == 0 ? "" : value;
        if (value.indexOf(".") > 0) {
          value = value.replace(/\.{2,}/g, ".");
          let arr = value.split(".");
          value = arr.length == 3 ? value.substr(0, value.length - 1) : value;
        }
      }
      // this.list[index].child[indexs].rate = value;
    },
    //离开输入框后增加小数点
    clearnumber(value, num, data, index, isTotal) {
      const m = this.changeDecimalBuZero(value, num);
      value = m;
      if (isTotal && this.form.totalAcreage) {
        
        this.$set(this.form, "totalAcreage", value);
        // console.log(this.form)
        return false
      }
      this.$set(data[index], "acreage", value);
    },
    clearRoomNumber(value, num, data, index, isRoom) {
      const m = this.changeDecimalBuZero(value, num);
      value = m;
      this.acreage = value;
    },
    changeDecimalBuZero(number, bitNum) {
      /// <summary>
      /// 小数位不够，用0补足位数
      /// </summary>
      /// <param name="number">要处理的数字</param>
      /// <param name="bitNum">生成的小数位数</param>
      if (number == 0) return 0;
      var f_x = parseFloat(number);
      if (isNaN(f_x)) {
        return 0;
      }
      var s_x = number.toString();
      var pos_decimal = s_x.indexOf(".");
      if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += ".";
      }
      while (s_x.length <= pos_decimal + bitNum) {
        s_x += "0";
      }
      return s_x;
    },
    // 搜索小区
    onSearchHouse() {
      // if (!this.searchValueHouse) return;

      this.searchLoad = true;

      this.communityList = [];

      requestCommunitySearch({ type: 1 }).then((res) => {
        this.searchLoad = false;
        // console.log(this.searchValueHouse);
        if (this.searchValueHouse !== "") {
          for (let k = 0; k < res.data.length; k++) {
            if (res.data[k].name.indexOf(this.searchValueHouse) > -1) {
              // console.log(res.data[k])
              this.communityList.push(res.data[k]);
            }
          }
        } else {
          this.communityList = res.data || [];
        }
      });
    },
    changeCommunity(house) {
      // console.log(house);
      this.form.buildingNo = "";
      this.form.roomNo = "";
      this.form.unitNo = "";
      this.form.communityName = house.name || "";
      this.form.communityId = house.id || "";
      this.form.priceModelId = house.priceModelId || "";
      if (this.form.priceModelId) {
        let obj = this.fixPriceList.find((item) => {
          return item.id == this.form.priceModelId;
        });
        // console.log(obj);
        if (!obj) {
          this.$toast("该小区未设置定价宝模板，请在ERP系统中修改");
          return false;
        }
        this.form.priceModelName = obj.name || "";
      }
      this.gainCommunityIndex(this.form.priceModelName);
      this.form.buildingType = house.buildingType;
      this.reset();
      this.showHouse = false;
    },
    onCancel() {
      this.showHouse = false;
    },
    getFixPriceList() {
      requestFixPriceSelect()
        .then((res) => {
          this.fixPriceList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectBuildingType() {
      if (this.form.communityId) {
        return false;
      }
      this.showBuildingTypeModel = true;
    },
    gainCommunityIndex(name) {
      this.communityIndex = this.fixPriceList.findIndex((item, index) => {
        return name == item.name;
      });
    },
    // 选择装修后户型
    confirmDecorationAfter(item, index) {
      if (!item) return;
      // console.log(item);
      if (
        this.form.chamberNum == item[0].text &&
        this.form.hallNum == item[1].text &&
        this.form.toiletNumber == item[2].text &&
        this.form.kitchenNum == item[3].text &&
        this.form.balconyNum == item[4].text
      ) {
        this.showDecorationAfter = false;
        return false;
      }
      this.form.chamberNum = item[0].text;
      this.form.hallNum = item[1].text;
      this.form.toiletNumber = item[2].text;
      this.form.kitchenNum = item[3].text;
      this.form.balconyNum = item[4].text;

      // 初始化
      this.bNum = 0;
      this.form.roomList = [];
      this.form.toiletList = [];
      this.form.hallList = [];
      this.form.kitchenList = [];
      this.form.balconyList = [];
      this.reset();
      // this.form.totalAcreage = "";
      // this.form.layoutList = [];

      for (let i = 0; i < this.form.chamberNum; i++) {
        this.form.roomList.push({
          index: i,
          bayWindow: 0,
          optimization: 0,
          toilet: 0,
          balcony: 0,
          acreage: "",
          toward: "",
          price: "",
          priceRemark: "",
          imageUrls: [],
          name: "房间" + this.roomNameList[i],
        });
      }
      for (let i = 0; i < this.form.toiletNumber; i++) {
        this.form.toiletList.push({
          index: i,
          acreage: "",
          imageUrls: [],
          toiletFlag: 0,
          name: "卫生间" + this.roomNameList[i],
        });
      }
      for (let i = 0; i < this.form.hallNum; i++) {
        this.form.hallList.push({
          index: i,
          acreage: "",
          imageUrls: [],
          name: "客厅" + this.roomNameList[i],
        });
      }
      for (let i = 0; i < this.form.kitchenNum; i++) {
        this.form.kitchenList.push({
          index: i,
          acreage: "",
          imageUrls: [],
          name: "厨房" + this.roomNameList[i],
        });
      }
      for (let i = 0; i < this.form.balconyNum; i++) {
        this.form.balconyList.push({
          index: i,
          acreage: "",
          imageUrls: [],
          name: "阳台" + this.roomNameList[i],
        });
      }
      // this.form.layoutList.push({
      //   acreage: "",
      //   imageUrls: [],
      //   name:""
      // });
      this.showDecorationAfter = false;
    },
    getDecorationType() {
      requestJointOrderDecorationType().then((res) => {
        this.decorationTypeList = res.data;
      });
    },
    floorChange() {
      if (this.form.floorNumber == 0 || this.form.totalFloor == 0) {
        this.$toast("楼层数不能为0");
      }
      if (this.form.floorNumber > this.form.totalFloor) {
        this.$toast("当前楼层不能大于总楼层");
      }
    },
    //跟踪记录状态
    getTrackRecord() {
      let param = {
        status: this.$route.query.status,
        lastStatus:
          this.$route.query.status == 109 ? this.$route.query.lastStatus : null,
      };
      requestChildStatus(param).then((res) => {
        // console.log(res.data);
        this.trackRecordList = res.data;
      });
    },

    // 编辑房间信息
    showRoomAddPopup(item, index) {
      this.houseRoomIndex = index;
      this.acreage = this.form.roomList[index].acreage;
      this.toward = this.form.roomList[index].toward;
      this.optimization = this.form.roomList[index].optimization;
      this.balcony = this.form.roomList[index].balcony;
      this.bayWindow = this.form.roomList[index].bayWindow;
      this.toilet = this.form.roomList[index].toilet;
      // console.log(this.form.roomList[index]);
      this.toiletDisabled = this.form.roomList[index].toiletDisabled;
      this.showRoomAdd = true;
    },
    cancel() {
      this.showRoomAdd = false;
      return false;
    },
    //获取七牛token
    getQiniuToken() {
      requestQiniuToken()
        .then((res) => {
          this.qiniuData.token = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //图片上传前校验，压缩
    beforeRead(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt8M = file.size / 1024 / 1024 < 8;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$toast.fail("图片只能是 JPG/PNG 格式！");
        return false;
      }
      if (!isLt10M) {
        this.$toast.fail("图片大小不能超过 10MB!");
        return false;
      }
      this.qiniuData.key = Date.now() + file.name;
      return new Promise((resolve, reject) => {
        compressAccurately(file, 400).then((fileMin) => {
          let data = new FormData();
          data.append("token", this.qiniuData.token);
          data.append("key", this.qiniuData.key);
          data.append("file", fileMin);

          request({
            url: this.$store.state.qiniuUpload,
            method: "post",
            processData: false,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: data,
          })
            .then((res) => {
              let newFile = fileMin;
              newFile.key = res.key;

              resolve(newFile);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
    },
    // 编辑房间信息
    onSubmitForm(index) {
     
       var Inverse = false
          if(this.form.roomList[index].balcony != this.balcony ){
            Inverse = true
          }
          this.form.roomList[index].acreage = this.acreage;
          this.form.roomList[index].toward = this.toward;
          this.form.roomList[index].optimization = this.optimization;
          this.form.roomList[index].balcony = this.balcony;
          this.form.roomList[index].bayWindow = this.bayWindow;
          this.form.roomList[index].toilet = this.toilet;
          var tNum = 0;
          var bNum = 0;
          this.form.roomList.forEach((item, index) => {
            tNum += item.toilet;
            bNum += item.balcony;
          });
          // console.log('end')
         
          for (let i = 0; i < this.form.toiletList.length; i++) {
            this.form.toiletList[i].toiletFlag = 0;
          }
           
          if (tNum > 0) {
             if (this.form.toiletList.length == 0) {
              this.toilet = 0;
              this.form.roomList[index].toilet = 0;
              this.$toast("卫生间数量为0，无法勾选");
              console.log(tNum)
              return false
            }
            console.log(this.form.toiletList.length);
            if (tNum > this.form.toiletList.length) {
              
              this.toilet = 0;
              this.form.roomList[index].toilet = 0;
              // this.form.roomList[index].toiletDisabled = true
              this.$toast("其他房间已勾选过独卫，无法勾选");``
               this.validateBalcony(bNum,index,Inverse);
              for (let i = 0; i < this.form.toiletList.length; i++) {
                this.form.toiletList[i].toiletFlag = 1;
              }
              return false;
            } else {
              for (let i = 0; i < tNum; i++) {
                this.form.toiletList[i].toiletFlag = 1;
              }
            }
          }
          
        var t = this.validateBalcony(bNum,index,Inverse);
        this.reset();
        if(t)  this.showRoomAdd = false;
        console.log(this.showRoomAdd)
      // console.log(this.form)
    },
    validateBalcony(num,index,Inverse){
          if (this.form.balconyNum == 0 && this.balcony) {
            this.balcony = 0;
            this.form.roomList[index].balcony = 0;
            this.$toast("阳台数量为0，无法勾选");
            return false;
          }
          if (num > Number(this.form.balconyNum) && this.form.balconyNum != 0) {
            this.balcony = 0;
            this.form.roomList[index].balcony = 0;
            this.$toast("其他房间已勾选过独立阳台,无法勾选");
            return false;
          }
          // console.log("w",Inverse)
          if(this.form.roomList[index].balcony && Inverse){
            this.form.balconyList.pop();
          }else{
            if(Inverse){
                 for (let i = 0; i < this.form.balconyNum - this.form.balconyList.length; i++) {
                this.form.balconyList.push({
                  index: i,
                  acreage: "",
                  imageUrls: [],
                  name:
                    this.form.balconyNum > 0 ? "阳台" + this.roomNameList[this.form.balconyList.length] : "阳台",
                });
             }
            }
          
          }
          return true
    },
    // 实勘保存
    onSubmit(type) {
      let totalAcreage = 0;
      for (let i = 0; i < this.form.roomList.length; i++) {
        this.form.roomList[i].imageList = [];
        this.form.roomList[i].imageUrls.forEach((item, index1) => {
          this.form.roomList[i].imageList.push(item.url);
        });
        if (!this.form.roomList[i].acreage || !this.form.roomList[i].toward) {
          this.$toast(`${this.form.roomList[i].name}的面积或朝向不能为空`);
          return;
        }
        totalAcreage += +this.form.roomList[i].acreage;
      }
      this.form.balconyList.forEach((d, index) => {
        this.form.balconyList[index].imageList = [];
        d.imageUrls.forEach((item, index1) => {
          this.form.balconyList[index].imageList.push(item.url);
          // .push(item.url)
        });
        totalAcreage += +d.acreage;
      });
       this.form.toiletList.forEach((d, index) => {
        this.form.toiletList[index].imageList = [];
        d.imageUrls.forEach((item, index1) => {
          this.form.toiletList[index].imageList.push(item.url);
          // .push(item.url)
        });
        totalAcreage += +d.acreage;
      });
      this.form.hallList.forEach((d, index) => {
        this.form.hallList[index].imageList = [];
        d.imageUrls.forEach((item, index1) => {
          this.form.hallList[index].imageList.push(item.url);
          // .push(item.url)
        });
        totalAcreage += +d.acreage;
      });
      this.form.kitchenList.forEach((d, index) => {
        this.form.kitchenList[index].imageList = [];
        d.imageUrls.forEach((item, index1) => {
          this.form.kitchenList[index].imageList.push(item.url);
          // .push(item.url)
        });
        totalAcreage += +d.acreage;
      });
      this.form.layoutList.forEach((d, index) => {
        this.form.layoutList[index].imageList = [];
        d.imageUrls.forEach((item, index1) => {
          this.form.layoutList[index].imageList.push(item.url);
          // .push(item.url)
        });
        totalAcreage += +d.acreage;
      });
      // console.log(totalAcreage);
      if (totalAcreage > this.form.totalAcreage) {
        this.$toast(`房间面积大于总面积,请核实后再提交`);

        return;
      }
      // console.log(this.form);
      let param = {
        communityId: this.form.communityId,
        buildingNo: this.form.buildingNo,
        unitNo: this.form.unitNo,
        roomNo: this.form.roomNo,
      };
      if (
        param.communityId &&
        param.buildingNo &&
        param.unitNo &&
        param.roomNo
      ) {
        let verify = [];
        verify.push(param);
        requestValidHouse(verify)
          .then((res) => {
            if (res.data) {
              this.$toast(`该房源已存在，无法提交`);
              return false;
            } else {
              this.saveLoad = true;

              requestJointOrderUpdate(this.form)
                .then((res) => {
                  this.saveLoad = false;
                  this.$router.back();
                })
                .catch((err) => {
                  this.saveLoad = false;
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.saveLoad = true;

        requestJointOrderUpdate(this.form)
          .then((res) => {
            this.saveLoad = false;
            this.$router.back();
          })
          .catch((err) => {
            this.saveLoad = false;
          });
      }
    },
    // 清空小区
    clearCommunityName() {
      this.form.communityName = "";
      this.form.communityId = "";
      this.form.priceModelName = "";
      this.form.priceModelId = "";
      this.form.buildingType = null;
      this.form.buildingNo = "";
      this.form.roomNo = "";
      this.form.unitNo = "";
      this.form.expectPrice = null;
      this.form.priceRemark = null;
    },
    // 生成预计出租价格
    createPrice() {
      let totalAcreage = 0;
      if (!this.form.priceModelId) {
        this.$refs["form"].validate("priceModelId");
        this.$toast(`获取失败：定价宝模板不能为空`);
        return;
      }
      if (!this.form.decorationType) {
        this.$refs["form"].validate("decorationType");
        this.$toast(`获取失败：装修类型不能为空`);
        return;
      }
      if (!this.form.totalAcreage) {
        this.$refs["form"].validate("totalAcreage");
        this.$toast(`获取失败：总面积不能为空`);
        return;
      }
      if (!this.form.floorNumber) {
        this.$refs["form"].validate("floorNumber");
        this.$toast(`获取失败：楼层信息不能为空`);
        return;
      }
      if (!this.form.totalFloor) {
        this.$refs["form"].validate("totalFloor");
        this.$toast(`获取失败：楼层信息不能为空`);
        return;
      }
      //  房间
      for (let i = 0; i < this.form.roomList.length; i++) {
        if (!this.form.roomList[i].acreage || !this.form.roomList[i].toward) {
          this.$toast(`${this.form.roomList[i].name}的面积或朝向不能为空`);
          return;
        }
        totalAcreage += +this.form.roomList[i].acreage;
      }
      // 卫生间
      for (let i = 0; i < this.form.toiletList.length; i++) {
        if (!this.form.toiletList[i].acreage) {
          this.$toast(`${this.form.toiletList[i].name}的面积不能为空`);
          return;
        }
        totalAcreage += +this.form.toiletList[i].acreage;
      }
      // 客厅
      for (let i = 0; i < this.form.hallList.length; i++) {
        if (!this.form.hallList[i].acreage) {
          this.$toast(`${this.form.hallList[i].name}的面积不能为空`);
          return;
        }
        totalAcreage += +this.form.hallList[i].acreage;
      }

      // 厨房
      for (let i = 0; i < this.form.kitchenList.length; i++) {
        if (!this.form.kitchenList[i].acreage) {
          this.$toast(`${this.form.kitchenList[i].name}的面积不能为空`);
          return;
        }
        totalAcreage += +this.form.kitchenList[i].acreage;
      }
      // 阳台
      for (let i = 0; i < this.form.balconyList.length; i++) {
        if (!this.form.balconyList[i].acreage) {
          this.$toast(`${this.form.balconyList[i].name}的面积不能为空`);
          return;
        }
        totalAcreage += +this.form.balconyList[i].acreage;
      }
      if (totalAcreage > this.form.totalAcreage) {
        this.$toast(`房间面积大于总面积,请核实后再提交`);

        return;
      }
      this.expectPriceLoading = true;
      // this.form.forEach((item,index)=>{

      // })
      requestCreatePrice(this.form)
        .then((res) => {
          this.expectPriceLoading = false;
          this.form.expectPrice = res.data.expectPrice;
          this.form.priceRemark = res.data.priceRemark;
          // this.form.roomList =
          this.form.roomList.forEach((item, index) => {
            item.price = res.data.roomList[index].price;
            item.priceRemark = res.data.roomList[index].priceRemark;
          });
          // res.data.roomList.forEach()
          this.$toast(`获取预计出租价格${this.form.expectPrice}`);
        })
        .catch((err) => {
          this.expectPriceLoading = false;
        });
    },
    lookPriceRemark() {
      this.showRemark = true;
      // this.$toast({
      //   duration: 0,
      //   overlay: true,
      //   closeOnClickOverlay: true,
      //   message: `${this.form.priceRemark}`,
      // });
    },
    formatDate(date) {
      return formatDate(date);
    },
    formatDatetime(date) {
      return formatDatetime(date);
    },
    validNum(val) {
      return validNum(val);
    },
    validNumMoreDecimal2(val) {
      return validNumMoreDecimal2(+val);
    },
    changeReset() {
      this.reset();
    },
    reset() {
      this.form.expectPrice = null;
      this.form.priceRemark = null;
      // console.log('reset',this.form.expectPrice)
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#jointOrderAFollow {
  background-color: #fff;
}
/deep/.van-field__error-message {
  text-align: right;
}
/deep/.van-checkbox--horizontal {
  margin-bottom: 0.32rem;
}
.btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0.1rem;
  overflow: hidden;
  display: flex;
  /deep/.van-button {
    margin-left: -1px;
    border: none;
    border-radius: 0;
    flex: 1;
    &:not(:last-child)::after {
      height: 50%;
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      border-right: 0.02667rem solid #ebedf0;
      z-index: 99;
    }
  }
  .font4 {
    width: 2.4rem;
  }
  .font3 {
    width: 1.8rem;
  }
  .font5 {
    width: 51%;
  }
  .font1 {
    width: 100%;
    margin-left: 0;
  }
}
/deep/.van-checkbox__icon--checked .van-icon {
  color: #ffffff;
  background-color: #fd7e2d;
  border-color: #fd7e2d;
}
/deep/.van-radio__icon--checked .van-icon {
  color: #ffffff;
  background-color: #fd7e2d;
  border-color: #fd7e2d;
}
.floor_box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    border-bottom: 0.02667rem solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  .van-field__control {
    border: 1px solid #dcdfe6 !important;
  }
}
.house_add {
  text-align: initial;
  background: #fff;
  color: #323233;
  font-size: 0.32rem;
  .title {
    font-size: 14px;
  }
  /deep/.van-checkbox__label--disabled {
    color: #323233 !important;
  }
  /deep/.van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
    color: #ffffff;
    background-color: #fd7e2d;
    border-color: #fd7e2d;
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  .option {
    width: 33.3%;
    margin: 0.18rem 0;
    display: flex;
  }
  .top.van-row {
    display: flex;
    justify-content: space-between;
  }
  .top {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    margin-bottom: 0.15rem;
    .box {
      // width: 33.33%;
      display: flex;
      &:nth-of-type(2) {
        justify-content: center;
      }
      &:nth-of-type(3) {
        justify-content: flex-end;
        margin-right: 0.54rem;
      }
    }
  }
  /deep/.van-uploader__preview {
    width: 2.8rem;
    height: 2.8rem;
    margin: 0 0.1rem;
  }
  /deep/.van-field__label {
    width: auto;
  }
  /deep/.van-uploader__preview:nth-of-type(3) {
    margin-right: 0;
  }
  /deep/.van-uploader__preview-image {
    width: 100%;
    height: 2.8rem;
  }
  /deep/.van-uploader__upload {
    width: 2.8rem;
    height: 2.8rem;
  }
  .has_border /deep/.van-field__control {
    border: 1px solid #ccc;
    padding-left: 0.1rem;
  }
}
.text {
  text-align: center;
  .van-field {
    padding: 0;
    /deep/input {
      text-align: center;
    }
  }
}
/deep/.van-field--error .van-field__control::placeholder {
  color: #cacaca;
}
.room_option {
  display: flex;
  position: absolute;
  width: 100%;
  top: 1.17333rem;
  left: 0px;
  z-index: 7848;
  background: #fff;
  height: 50px;
  align-items: center;
  span {
    flex: 1;
  }
}
.search {
  width: 100%;

  height: 100%;

  position: fixed;

  top: 0;

  background-color: #fff;

  z-index: 99;

  overflow: scroll;

  .van-search {
    /deep/i {
      line-height: 0.84rem;
    }

    /deep/input {
      border: none;
    }
  }
}
/deep/ .van-submit-bar {
  position: inherit;
}
.van-submit-bar__bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .create_price {
    display: flex;
    align-items: center;
  }
}
.priceRemark::-webkit-scrollbar {
display: none;/*隐藏滚轮*/
}
</style>
